export const endpoints = {
  authenticate: `/auth/authenticate`,
  getMe: `/auth/getMe`,
  user: `/users`,
  updateUser: (id: string) => `/users/${id}`,

  contact: `/contact`,

  project: `/projects`,
  myProjects: `/projects/mine`,
  getProjectById: (id: string) => `/projects/${id}`,

  getAllCandidates: (jobId: string) => `/candidates/all/job/${jobId}`,
  candidate: `/candidates`,
  uploadCandidates: `/candidates/upload`,
  getSingleCandidate: (id: string) => `/candidates/${id}`,
  emailRequest: `/candidates/emailRequest`,

  myCalendar: `/calendar/mine`,
  getMyCalendar: (month: number, year?: number) => {
    const currentYear = year ?? new Date().getFullYear();
    return `/calendar/mine/${month + 1}?year=${currentYear}`;
  },
  availabilityByProjectId: (id: string, month: number, year?: number) => {
    const currentYear = year ?? new Date().getFullYear();
    return `/calendar/availability/${id}?month=${month + 1}&year=${currentYear}`;
  },
  availableManagers: `/calendar/availableManagers`,
  scheduleInterview: `/calendar/scheduleInterview`,
  rescheduleInterview: `/calendar/rescheduleInterview`,
  rescheduleCandidateInterview: `/calendar/rescheduleCandidateInterview`,

  emailSubscription: "/email-subscription/email",
  paymentHistory: "/subscription/history",

  getPreSignedUrl: `s3Upload/getUploadUrl`,

  createRemark: "/remarks/new",
  getRemarks: (id: string) => `/remarks/${id}`,

  candidateApplications: `/candidates/applications`,

  getMyCandidateCalendar: (month: number, year?: number) => {
    const currentYear = year ?? new Date().getFullYear();
    return `/calendar/candidate/mine/${month}?year=${currentYear}`;
  },
  myCandidateCalendar: '/calendar/candidate/mine',
  getCandidateCalendar: (candidateId: string, month: number, year?: number) => {
    const currentYear = year ?? new Date().getFullYear();
    return `/calendar/candidate/${candidateId}?month=${month}&year=${currentYear}`;
  },
  getManagerCalendar: (managerId: string, month: number, year?: number) => {
    const currentYear = year ?? new Date().getFullYear();
    return `/calendar/manager/${managerId}?month=${month + 1}&year=${currentYear}`;
  },

  slotSuggestions: {
    preview: (jobApplicationId: string, userIds: string[]) =>
      `/calendar/suggestions/preview?jobApplicationId=${jobApplicationId}&${userIds.map((id) => `userIds=${id}`).join("&")}`,
    send: "/calendar/suggestions/send",
    offer: "/calendar/suggestions/offer",
    mine: "/calendar/suggestions/mine",
    accept: (id: string) => `/calendar/suggestions/${id}/accept`,
    dismiss: (id: string) => `/calendar/suggestions/${id}/dismiss`,
  },

  createInvite: "/invites",
  validateInvite: (token: string) => `/invites/validate/${token}`,
  acceptInvite: (token: string) => `/invites/accept/${token}`,
  declineInvite: (token: string) => `/invites/decline/${token}`,
  listInvitesByJob: (jobId: string) => `/invites?jobId=${jobId}`,
  jobs: {
    recruiter: {
      myJobs: '/jobs/recruiter/my-jobs',
    },
    manager: {
      myJobs: '/jobs/manager/my-jobs',
    },
  },
  getInvitationsForCandidate: (candidateId: string) => `/invites?candidateId=${candidateId}`,
  fetchRecruiterJobs: '/jobs/recruiter/my-jobs',
  createJob: '/jobs',
  getJobById: (jobId: string) => `/jobs/${jobId}`,
  getJobs: '/jobs',
  handleSendInvite: '/invites',
  candidatesAcceptedInvites: '/candidates/accepted-invites',
  candidatePool: (recruiterId: string) => `/jobs/candidate-pool?recruiterId=${recruiterId}`,
  myJobApplications: '/job-applications/my-applications',
  getRemarksForJobApplication: (jobApplicationId: string) => `/remarks/application/${jobApplicationId}`,
  createRemarkForJobApplication: (jobApplicationId: string) => `/remarks/application/${jobApplicationId}`,
  candidateProfile: '/candidates/profile',
  remarksForApplication: (jobApplicationId: string) => `/remarks/application/${jobApplicationId}`,
  profile: '/profile',
  saveProfile: '/profile',
  getProfileByUserId: (userId: string) => `/profile?userId=${userId}`,
  getProfileByInviteToken: (token: string) => `/profile/invite/${token}`,
  recruiterMyJobs: '/jobs/recruiter/my-jobs',
  getSubmittedApplicationsForJob: (jobId: string) => `/job-applications/submitted-to-manager?jobId=${jobId}`,
  getSingleJobApplication: (applicationId: string) => `/job-applications/${applicationId}`,
  updateJobApplicationResume: (applicationId: string) => `/job-applications/${applicationId}/resume`,
  updateJobPriority: (jobId: string) => `/jobs/${jobId}/priority`,
  managerMyJobs: '/jobs/manager/my-jobs',
  notifications: {
    myNotifications: "/notifications/my",
    markAsRead: (id: string) => `/notifications/${id}/read`,
  },
  reporting: {
    hiringMetrics: "/reporting/hiring-metrics",
    timeToHire: "/reporting/time-to-hire",
    conversionFunnel: "/reporting/conversion-funnel",
    performanceSummary: "/reporting/performance-summary",
    jobPerformance: "/reporting/job-performance",
    candidateSourceAnalysis: "/reporting/candidate-source-analysis",
  },
  screening: {
    screenApplication: "/screening/screen-application",
    getResult: "/screening/result",
    screenMultiple: "/screening/screen-multiple",
    autoScreenJob: "/screening/auto-screen-job",
  },
};

